module.exports = __webpack_public_path__ + "files/985071e65380f9717da2192015460e13.png";